import React from 'react';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import Layout from './layout/Layout';
import FulfillmentBoard from './FulfillmentBoard';
import OrdersList from './OrdersList';

export default function OrdersWorkspace({ initialView = 'fulfillment' }) {
  const [view, setView] = React.useState(initialView);

  return (
    <Layout>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" fontWeight={800}>Orders</Typography>
          <Typography color="text.secondary">
            Fulfill paid orders visually or use the existing spreadsheet and Excel export.
          </Typography>
        </Box>

        <Paper className="orders-workspace-controls" sx={{ p: 1.5 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1}>
            <Button
              fullWidth
              size="large"
              variant={view === 'fulfillment' ? 'contained' : 'outlined'}
              onClick={() => setView('fulfillment')}
            >
              Fulfillment Dashboard
            </Button>
            <Button
              fullWidth
              size="large"
              variant={view === 'spreadsheet' ? 'contained' : 'outlined'}
              onClick={() => setView('spreadsheet')}
            >
              Excel Spreadsheet
            </Button>
          </Stack>
        </Paper>

        {view === 'fulfillment' ? (
          <FulfillmentBoard embedded />
        ) : (
          <OrdersList embedded />
        )}
      </Stack>
    </Layout>
  );
}
